  $(document).ready(function(){
   var width = $(window).width();
    if(width > 767){
 	var pgurl= window.location.pathname; 
    $(".navigation__child-tier ul > li > a").each(function(){
      
      
      var url = $(this).attr("href");
      
      if(url == pgurl){
        
      $(this).addClass("current-menu");
        $(this).parents().parents().addClass("prcurrent-menu");
      }
      
    });
     $(this).parents().css('display','block');
    var menuprnt= $('.navigation__item--with-children.prcurrent-menu > a').first().text();
    $('.navigation .navigation__item--with-children > a').each(function(){
    	var childmenu= $(this).text();
        if(menuprnt == childmenu){
          $(this).addClass("mainparent");
         
        }
        });
      
      /*Menu show on click*/
      $(".navigation__item--with-children > a").click(function(){
          var menuurl = $(this).attr("href");
          $(this).attr("href","javascript:void(0)");
          $(this).css("color","#37a8bc!important");
          $('.navigation__child-tier .navigation__column .navigation__child-tier').addClass('menuhide');
      	      
    	});
      $('.navigation__link.navigation__column-title').click(function(){
        	$('.navigation__link.navigation__column-title').removeClass("bluecolor");
            $(this).siblings().removeClass('menuhide');
	        $(this).parent().siblings().children('.navigation__child-tier .navigation__column .navigation__child-tier').addClass('menuhide');
        	$('.navigation__link.navigation__column-title').not(this).removeClass("new11");
        	$('.navigation__link.navigation__column-title').not(this).parent().children('.navigation__child-tier .navigation__column .navigation__child-tier').addClass('menuhide');
        
            if ($(this).hasClass('new11')){
              $(this).removeClass('new11');
              $(this).parent().children('.navigation__child-tier .navigation__column .navigation__child-tier').addClass('menuhide');
            }else{
               $(this).addClass('new11');
               $(this).parent().children('.navigation__child-tier .navigation__column .navigation__child-tier').removeClass('menuhide');

            }
        
      });
      
  
    $(".navigation__child-tier ul > li >  a").each(function(){
      var urldrop = $(this).attr("href");
//       console.log(urldrop);
//       console.log(pgurl);
      if(urldrop == pgurl){
        
        console.log(pgurl,urldrop);
        
//         if($('.mainparent').parents().hasClass('navigation__item--with-children')){
        if($(this).parents('.navigation__item').hasClass(localStorage.getItem("clickmenu").replace('.',''))){
          setTimeout(function () {
         
            $(".navigation__item"+localStorage.getItem("clickmenu")+"> a").click();
            $(".navigation__item--with-children.prcurrent-menu").click();
    
//              $('.navigation__item.navigation__item--with-children .mainparent').trigger('click');
             $('.current-menu').closest('.navigation__child-tier.prcurrent-menu').removeClass('menuhide');
            // $('.current-menu').closest('.navigation__child-tier.prcurrent-menu').parent().first().addClass("bluecolor");
             $('.current-menu').closest('.navigation__child-tier.prcurrent-menu').parent().find('a:first').addClass("bluecolor");
          }, 200);
//         }
           }
      }
      });
    
    
    /*Remove Submenu on Mainparent click*/
    
//     $(".navigation__item.navigation__item--with-children > a").click(function () {
//        var parentxt= $(this).text();
//        var activeparentxt= $('.navigation__item--show-children .navigation__link').first().text();
//       console.log(parentxt);
//       console.log(activeparentxt);
      
//       if(parentxt == activeparentxt){
//         $('.navigation__item--show-children .navigation__link').first().parent().find('.navigation__child-tier').toggleClass("parenthide");
//       }
       
   
//     });
    
    }
    
//     $('li#menuitem-4').hover(function(){
//     	$(this).click();
//     });
   });

//   $(document).ready(function(){
    
//     $(".shipping-info").click(function() {
//       $(".popup-shipping-overlay, .popup-shipping-overlay .popup-content").addClass("active");
//       $("#cover").show();
//     });

//     //removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
//     $(".close_popup, .popup-shipping-overlay").click(function() {
//       $(".popup-shipping-overlay, .popup-shipping-overlay .popup-content").removeClass("active");
//       $("#cover").hide();
//     });
    
//     $(".local-info").click(function() {
//       $(".popup-local-overlay, .popup-local-overlay .popup-content").addClass("active");
//       $("#cover").show();
//     });

//     //removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
//     $(".close_popup, .popup-local-overlay").click(function() {
//       $(".popup-local-overlay, .popup-local-overlay .popup-content").removeClass("active");
//       $("#cover").hide();
//     });
    
  
    
//   });


//$(document).ready(function(){
//   $(".navigation--main .navigation__tier-1-container .navigation__item.navigation__item--with-children a:first-child").each(function(){
// 	  var itemtext= $('.navigation__item.navigation__item--with-children a').text();
//       console.log($('.navigation__item.navigation__item--with-children a').text());
// //     if(itemtext == 'flavors'){
// //     	$(this).addClass('clickmenu');
// //     }
//    });
//    var menuprnt1= $('.navigation__item--with-children > a').first().text();
 
//   $('.navigation__item--with-children > a:first-child').each(function(){
//      var itemtext=$(this).text();
//     	console.log(itemtext);
//     if(itemtext == 'flavors'){
//       	$(this).addClass('clickmenu');
//      }
//   });
//   $('.navigation__item--with-children > a:first-child').hover(function(){
//      var itemtext=$(this).text();
//     	console.log(itemtext);
//     if(itemtext == 'flavors'){
//       	//$(this).addClass('clickmenu');
//       $(this).siblings('#NavigationTier2-5').css('display','none');
//      }
//   });
//   $('.navigation__item--with-children > a:first-child').click(function(){
//   	var itemtext1=$(this).text();
//     if(itemtext1 == 'flavors'){
//       $(this).siblings('#NavigationTier2-5').css('display','block');
//       $(this).siblings('#NavigationTier2-5').removeClass('parenthide');
//       $(this).closest('.navigation__item--with-children').addClass('.navigation__item--show-children');
//      }
//   });
//    $('.navigation__item--with-children > a:first-child').mouseleave(function(){
//      var itemtext2=$(this).text();
//     if(itemtext2 == 'flavors'){
//       $(this).siblings('#NavigationTier2-5').css('display','block');
//      }
//   });
//});


/*Selectbox*/
// $(document).ready(function(){
//   //alert('helo');
// $(".bold_option_element option[value='35968850296989']").each(function() {
//     //$('#product-form-template--15585586020509__main-2343758851 .bold_option.bold_option_uploadfile').css('display','block');
//   $(this).remove();
// });
// });